var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWomanHairstyle4A(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Woman_x5F_hairstyles:"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x34__3_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x34_a_4_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#862618",
    d: "M402.6,78.5c-2.1-0.7-4.5-1.2-7.1-1.8c-4.1-0.8-8.6-1.5-13.4-2.1c-0.9-0.1-1.8-0.2-2.7-0.3 c-8.7-0.8-18-1.1-26.8-0.7c-0.8,0-1.5,0.1-2.3,0.1c-5.5,0.3-10.6,1-15.2,1.9c-0.4,0.1-0.8,0.2-1.2,0.2c-1.1,0.2-2.2,0.5-3.4,0.7 c-9.5,2.1-19,5-27.2,10.4c-0.5,0.3-1,0.7-1.5,1.1c-2.7,2-5.4,4-7.5,6.4c36.1-21,81-22.3,119-7.6 C411.2,82.4,407.7,80.1,402.6,78.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#490500",
    d: "M291.2,107.4c1,3.3,3.2,6.1,5.6,7.9c5.9-3.7,12-6.8,18.3-9.2c6.3-2.4,12.7-4.3,19.3-5.6 c4.9-1,9.9-1.7,15-2c5-0.4,10.1-0.4,15.1-0.1c13.9,0.8,27.4,4.2,39.9,10c0.6-0.2,1.2-0.5,1.8-0.8 C372.3,85.7,324.8,82,291.2,107.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#490500",
    d: "M398.6,38.1c-2.4-0.6-5-0.7-8-0.2c-0.1-0.3-0.3-0.6-0.5-0.9c-1,10-3.5,26.1-10.8,37.4 c0.9,0.1,1.8,0.2,2.7,0.3C390.3,67.9,398.7,50.9,398.6,38.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#490500",
    d: "M364.6,28.9c-2.8,1-5.6,2.5-8,4.7c-0.2,13.4-2.3,28.5-6.2,40.2c0.7,0,1.5-0.1,2.3-0.1 C362.2,62.4,365.1,40.9,364.6,28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#490500",
    d: "M330.5,76.7c1.1-0.3,2.3-0.5,3.4-0.7c-9.1-10.1-16.3-23-17-36.2c0,0.1,0,0.2,0,0.2 c-2.6-0.1-5.2,0.1-7.7,0.7C310.1,56.7,320.5,70.4,330.5,76.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#711B0D",
    d: "M410.3,47.7c-2.5-4.5-6.4-8.2-11.7-9.6c0,12.8-8.3,29.8-16.6,36.5c4.8,0.5,9.3,1.2,13.4,2.1 c2.6,0.5,5,1.1,7.1,1.8c2.1-1.9,5-5.8,6.2-7.3C412.5,66.1,414.4,55,410.3,47.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#711B0D",
    d: "M364.6,28.9c0.5,12.1-2.4,33.6-12,44.8c8.8-0.4,18.1-0.1,26.8,0.7c7.2-11.3,9.7-27.3,10.8-37.4 C385.8,29.6,374.7,25.5,364.6,28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#711B0D",
    d: "M356.3,33.8c-7.7-12.4-37.7-8.7-39.4,6c0.7,13.1,7.9,26,17,36.2c0.4-0.1,0.8-0.2,1.2-0.2 c4.6-0.9,9.8-1.6,15.2-1.9c3.9-11.7,6-26.8,6.2-40.2C356.5,33.7,356.4,33.8,356.3,33.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#711B0D",
    d: "M309.2,40.7c-3.8,0.8-7.3,2.5-10.3,5.2c-7,6.5-9.1,14.7-7.5,23.6c1.6,9.2,5.3,12.5,11.9,17.6 c8.2-5.4,17.7-8.3,27.2-10.4C320.5,70.4,310.1,56.7,309.2,40.7z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#ABFF7F",
    strokeWidth: 0.1064,
    d: "M437.1,193.7L437.1,193.7C437.1,193.7,437.2,193.7,437.1,193.7 C437.3,193.6,437.2,193.5,437.1,193.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M463.9,189.2c0-1.9,0-3.7-0.2-5.5l0,0C463.9,185.4,463.9,187.3,463.9,189.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M429.1,124.1c-0.9-0.8-1.9-1.5-2.8-2.3C427.3,122.6,428.2,123.3,429.1,124.1L429.1,124.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M423.5,119.7c0.8,0.6,1.7,1.3,2.5,1.9C425.2,120.9,424.4,120.3,423.5,119.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#862618",
    d: "M463.9,189.2c0,0.1,0,0.3,0,0.4C463.9,189.4,463.9,189.3,463.9,189.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#862618",
    d: "M423,119.3c0.2,0.1,0.4,0.3,0.5,0.4C423.4,119.5,423.2,119.4,423,119.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#862618",
    d: "M455.3,156.8c-6.5-12.7-15.5-23.7-26.1-32.7l0,0c-0.9-0.8-1.8-1.5-2.8-2.3c-0.1-0.1-0.2-0.2-0.3-0.2 c-0.8-0.6-1.7-1.3-2.5-1.9c-0.2-0.1-0.3-0.3-0.5-0.4c-5.8-4.2-12-7.9-18.6-10.9c-12.4-5.8-25.9-9.2-39.9-10 c-5-0.3-10.1-0.3-15.1,0.1s-10,1-15,2c-6.6,1.3-13.1,3.2-19.3,5.6c-6.3,2.4-12.4,5.5-18.3,9.2c-22.6,14.1-41.2,36.6-48.1,62.2 c-1.8,11.1-1.1,23,6.3,28.3c3.8,2.7,9.2,4.1,13.6,2.7c1.4-1.7,2.4-4,2.6-6.4c-4.2-20.6-5.3-44.8,10.1-61.1 c-13.4,20.8-8.2,46.7-6,59.8c7.8-0.5,11.8-9.6,12.3-18.5c-0.8-21.2,1.1-49.2,21.7-65.4c-15.8,18.2-20.3,40.8-18,63.1 c10.6,0.4,19.5-5.8,21.7-14.4l0.1,0.1c-2.4-18.7-1.3-42.5,13.9-56.7c-10.3,13.1-15.2,40-9.6,59.6c5.9,2,13.2-1.5,15.4-6.3 c0.1,0.1,0.2,0.2,0.3,0.3c-2.8-18.7,0.6-41.4,11.1-56.7c-4.9,12.4-12.1,29.6-7.9,58.5c4.1,1,9.5-0.9,12.2-3.4 c0.1,0.2,0.2,0.5,0.3,0.7c-1.6-19.4,1.6-40.5,13.4-55.8c-9.2,17.8-12.3,39.7-9.2,60.1c5.1,2.7,12.7,2.1,15.9-2.8 c5.8-18.4,6.6-38.8,2.9-57.3c7.4,16.9,5.3,40.7-0.1,59.2c3.7,3.3,9.2,4.2,13.8,2.6c6.4-18.7,6.3-42.9,2.6-57 c7.5,15.6,6.4,36.5,1.9,54.1c0,0,0,0,0.1-0.1c0.7,4.4,6.5,10.3,10.4,11.9c4.5,1.9,7.6,2,11.9,0.5c4-20.3-0.1-46.4-4.4-54.3 c11.1,13.9,10.8,37.4,8,52.8c0.1,0,0.1-0.1,0.2-0.1c0.2,10.7,8.8,19.2,16.4,19.3c7.8-20.1,2.7-45.7-3.3-60.7 c13,20.2,13,45.5,7.6,61.3c-1.7,10.8,6.5,15.1,10.8,15.6c0.6,0.1,1.1,0.1,1.7,0.1c7.9-0.3,12.6-8.9,14-14.9 c0.1-0.3,0.1-0.6,0.2-0.9c0.3-1.9,0.4-3.8,0.4-5.7c0-0.1,0-0.3,0-0.4c0-1.9-0.1-3.7-0.2-5.5l0,0c-0.9-9.5-4.3-18.5-8.5-26.8 L455.3,156.8L455.3,156.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#5D1002",
    d: "M406.2,107.6c5-2.5,9.6-7.6,8.9-13.5c-0.3-2.8-1-5.1-1.8-7.1c-38.1-14.7-82.9-13.3-119,7.6 c-2.2,2.6-3.7,5.5-3.6,9.3c0,1.2,0.2,2.4,0.5,3.6C324.8,82,372.3,85.7,406.2,107.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5D1002",
    d: "M254.7,211.1c-3.6-1.8-5.8-5.3-7.1-9.3c-11.2,3.1-14.6,19.6-3.2,26.3c-5.8,5.6-2,19.5,4.3,23.8 c1.9-1.2,4.8-0.8,6.9,0c2.5,0.9,3.4,3.6,5.4,4.6c4.7,2.3,8.6-8.1,9-11.3c0.5-4-2.1-10.1-6.2-10.9c6.4-5.7,5.9-17-0.7-22.2 C260.5,212.7,257.6,212.5,254.7,211.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5D1002",
    d: "M449.2,211.1c-6,6.1-6.9,18.4,4.5,22.3c-3.2,3.2-5.6,8.9-5.1,13.1c0.4,3.3,2.6,9.3,7.3,6.9 c2-1,0.7-0.5,3.2-1.4c2.1-0.8,5-0.7,8-0.2c8.2-8.3,16.8-29.3,5.7-35.5c8.6-6,3-17.5-9.4-20.2 C461.9,202.2,457.1,210.9,449.2,211.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5D1002",
    d: "M477.8,190.1c-11.4-11.8-11.9-29.1-23-41.3c12,3.3,22.8,10.7,25.4,23.3c2.4-3.4-0.1-16.2-1.6-20.4 c-2.2-6.3-5.2-9.4-10.6-13.6c-6.8-5.3-15.1-7.4-23.1-9.4c-4.8-1.2-10.4-2.7-15.8-4.7c10.6,9,19.6,20,26.1,32.7h-0.1 c4.3,8.4,7.7,17.3,8.5,26.8c4.5,4.7,11.8,6.4,17.1,8.6C479.6,191.7,478.7,191.1,477.8,190.1z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#862618",
    d: "M426,121.6c0.1,0.1,0.2,0.2,0.3,0.2C426.2,121.7,426.1,121.7,426,121.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00C200",
    d: "M437.1,193.7L437.1,193.7C437.1,193.7,437.2,193.7,437.1,193.7C437.3,193.6,437.2,193.5,437.1,193.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#AB503E",
    d: "M255.1,205.7c-7.4-5.3-8.1-17.2-6.3-28.3c-1.3,4.7-2.1,9.5-2.5,14.4c0,3.3,0.4,6.7,1.4,9.9 c1.3,4,3.5,7.5,7.1,9.3c2.9,1.4,5.8,1.7,8.3,1c2.2-0.6,4.2-1.9,5.6-3.6C264.2,209.8,258.8,208.4,255.1,205.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB503E",
    d: "M271.3,202c0.1-0.6,0.1-1.2,0-1.8c1.5,0.4,2.8,0.6,4.1,0.5c-2.2-13.1-7.5-38.9,6-59.8 C265.9,157.2,267.1,181.4,271.3,202z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB503E",
    d: "M429.2,134.1c6,15,11,40.6,3.3,60.7c1.6,0,3.2-0.3,4.6-1.1l0,0c0-0.1,0.1-0.1,0,0l0,0 c-0.1,0.6-0.3,1.2-0.3,1.7C442.2,179.6,442.2,154.3,429.2,134.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB503E",
    d: "M412.3,177c1.1-0.4,2.3-0.9,3.6-1.5c2.8-15.4,3.1-38.9-8-52.8C412.3,130.6,416.3,156.7,412.3,177z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB503E",
    d: "M287.6,182.1c0.1-0.9,0.1-1.8,0.1-2.6c1.2,0.2,2.5,0.3,3.7,0.4c-2.3-22.4,2.2-44.9,18-63.1 C288.8,132.9,286.8,160.9,287.6,182.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB503E",
    d: "M333.2,162.5c0.9,0.9,2,1.5,3.2,1.8c-4.2-28.9,3-46.2,7.9-58.5C333.8,121,330.4,143.8,333.2,162.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB503E",
    d: "M313.1,165.6c1.3,1.4,2.8,2.4,4.3,2.9c-5.6-19.6-0.7-46.5,9.6-59.6C311.9,123.1,310.7,146.9,313.1,165.6 z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB503E",
    d: "M368.9,163c0.2-0.3,0.3-0.5,0.5-0.8c0.6,1,1.4,1.9,2.3,2.7c5.3-18.5,7.5-42.3,0.1-59.2 C375.5,124.2,374.7,144.7,368.9,163z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB503E",
    d: "M385.5,167.5c1.7-0.6,3.3-1.6,4.5-2.9c4.5-17.6,5.6-38.5-1.9-54.1C391.7,124.6,391.9,148.8,385.5,167.5z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB503E",
    d: "M348.8,161.5c0.8,1.8,2.3,3.3,4.2,4.3c-3.1-20.3-0.1-42.2,9.2-60.1C350.4,121.1,347.2,142.1,348.8,161.5 z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#AB503E",
    d: "M463.7,183.6L463.7,183.6c-0.3-3.9-1.1-7.7-2.2-11.4c1.7,8.1,1.9,16.7-0.7,23.6 c-2.3,6.2-8.4,13.1-15.2,14.8c0.7,0.2,1.4,0.4,2,0.4c0.6,0.1,1.1,0.1,1.7,0.1c7.9-0.3,12.6-8.9,14-14.9 c0.1-0.3,0.1-0.6,0.2-0.9c0.3-1.9,0.4-3.8,0.4-5.7c0-0.1,0-0.3,0-0.4C463.9,187.3,463.9,185.4,463.7,183.6z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWomanHairstyle4A);
export default __webpack_public_path__ + "static/media/woman_hairstyle_4a.c2f0171da475355882f5a2075af3dba7.svg";
export { ForwardRef as ReactComponent };